import { connect, MapDispatchToProps } from 'react-redux';
import { Props } from './JoinGroupButton';
import { requestJoinGroup } from '@wix/da-shared-react/pkg/redux/groups/actions';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'requestJoin'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  requestJoin: requestJoinGroup,
};

export default connect(null, mapDispatchToProps);
